import { timeout } from './timeout';

const TEL_INPUT_SELECTOR = 'input[type="tel"], input[data-tel-mask]';
const TEL_INPUT_PATTERN =
  '(\\+7 \\d{3} \\d{3}-\\d{2}-\\d{2})|(8 \\d{3} \\d{3}-\\d{2}-\\d{2})|(\\+\\d{11,14})';
const TEL_INPUT_MASK = '(+7 999 999-99-99)|(8 999 999-99-99)|(+99999999999[9{1,3}])';

type MaskedTelInput = HTMLInputElement & {
  inputmask?: unknown;
};

let inputmaskPromise: Promise<typeof import('inputmask').default> | undefined;

function getInputmask() {
  inputmaskPromise ??= import('inputmask').then((module) => module.default);

  return inputmaskPromise;
}

export async function initTelInput(input?: MaskedTelInput | null): Promise<void> {
  if (!input) return;
  if (input.inputmask) return;

  if (input.type === 'text' && input.hasAttribute('data-tel-mask')) {
    input.type = 'tel';
  }

  if (input.type !== 'tel') return;

  input.setAttribute('pattern', TEL_INPUT_PATTERN);

  const Inputmask = await getInputmask();
  new Inputmask({
    mask: TEL_INPUT_MASK,
    showMaskOnHover: false,
  }).mask(input);

  input.addEventListener('focus', () => {
    if (!input.value) input.value = '+7 ';
  });

  input.addEventListener('blur', () => {
    if (
      input.value.startsWith('+7 _') ||
      input.value.startsWith('+_') ||
      input.value.startsWith('8_')
    ) {
      input.value = '';
    }
  });
}

/**
 * Initializes telephone masks on input fields specified by selector inside the parent element.
 */
export async function initTelInputs(
  selector = TEL_INPUT_SELECTOR,
  parent: HTMLElement | Document = document
): Promise<void> {
  await timeout(4000);

  const inputs = parent.querySelectorAll<MaskedTelInput>(selector);
  inputs.forEach((input) => void initTelInput(input));
}
